import { render, staticRenderFns } from "./CompanyAddressesPanel.vue?vue&type=template&id=3aa615dd&scoped=true"
import script from "./CompanyAddressesPanel.vue?vue&type=script&lang=js"
export * from "./CompanyAddressesPanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyAddressesPanel.vue?vue&type=style&index=0&id=3aa615dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa615dd",
  null
  
)

export default component.exports